<template>
    <my-form
    v-model="form"
    table
    label-width="180px"
    @cancle="cancleHandler"
    @submit="submitHandler">
         <el-form-item
        class="table-full-row"
        label="是否推送交易中心"
        >
           <span v-if="jyzx"> 是</span>
           <span v-else> 否</span>
        </el-form-item> 
        <el-form-item
        class="table-full-row"
        label="是否推送公共服务平台"
        >
           <span v-if="hbpsp"> 是</span>
           <span v-else> 否</span>
        
        </el-form-item> 
        <my-tag type="danger" v-if="readonly" class="tip">不满足退回条件！涉及推送其他平台,请提工单处理</my-tag>
        <template slot="btn" slot-scope="scope">
            <el-button
            :disabled="readonly"
            @click="scope.submitHandler"
            type="danger"
            icon="el-icon-circle-check">
                退回
            </el-button>
            <el-button icon="el-icon-circle-close" @click="scope.cancleHandler">取消</el-button>
        </template>
    </my-form>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import DIALOG_FORM_PAGE_MIXIN from '@views/mixins/dialog-form-page'

import ThState from '../components/th-state'

export default {
    mixins: [ FORM_PAGE_MIXIN, DIALOG_FORM_PAGE_MIXIN ],
    components: { ThState },
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data: () => ({
        form: {},
        shbj: '',
        fbbj: '',
        hbpsp:'',
        jyzx:'',
        
    }),
    computed: {
        readonly() {
            return (
              this.hbpsp||this.jyzx
         );
        },
       
    },
    methods: {
        submitHandler() {
            ShowConfirm('确认退回中标公告？','danger',()=> { 
                this.$post(`${this.getGetters('mngUrl')}/Zbdl/tuihui/thzhongbiaogg.json`, this.data, (data, res) => {
                    ShowMsg(res.msg);
                    this.cancleHandler();
                });
            })
           
        }
    },
    created() {
        this.jspInit(`${this.getGetters('mngUrl')}/Zbdl/tuihui/thzhongbiaogginit.json`, this.data, data => {   
            this.form = data.model;
            this.hbpsp=data.hbpsp;
            this.jyzx=data.jyzx;  
        });
    }
}
</script>

<style scoped lang="scss">
.tip {
    margin: auto;
    margin-top: 10px;
}
</style>
